import { Record } from 'immutable';

export default class CustomerBjornLundenSettingRecord extends Record({
  id: undefined,
  staffingCompany: undefined,
  bjornLundenId: undefined,
}) {
}
